import { render, staticRenderFns } from "./add-params-setting.component.vue?vue&type=template&id=e6e8deb6"
import script from "./add-params-setting.component.vue?vue&type=script&lang=js"
export * from "./add-params-setting.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports